module.exports = __webpack_public_path__ + "img/ico3.e190809b.png";